import { FC, PropsWithChildren } from 'react';

import { ApplyButton, DiscardButton } from './buttons';
import { Spacer } from './spacer';

export const ValidatedActions: FC<
  PropsWithChildren<{
    onDiscarded: () => void;
    onApply: () => void;
  }>
> = ({ onDiscarded, onApply }) => (
  <>
    <DiscardButton onDiscarded={onDiscarded} className="flex-grow-1 flex-basis-50" />
    <Spacer />

    <ApplyButton onApply={onApply} className="flex-grow-1 flex-basis-50" />
  </>
);
